import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { Modal, Input, H3, H4 } from '@bigcommerce/big-design';

import { cartLayoutDisable } from '../../redux/actions/cartLayouts';

const DisableCartLayoutModal = ({ payload, cartLayoutId, showDisableCartLayoutModal, setShowDisableCartLayoutModal, cartLayout, disableCartLayout }) => {
  const update = () => {
    disableCartLayout(payload, cartLayoutId);
    setShowDisableCartLayoutModal(false);
  }

  return(
    <Modal
      actions={[
        {
          text: 'Cancel',
          variant: 'subtle',
          onClick: () => setShowDisableCartLayoutModal(false),
        },
        { text: 'Disable Cart Layout', onClick: () => update() },
      ]}
      closeOnClickOutside={true}
      closeOnEscKey={true}
      header="Disable Cart Layout"
      isOpen={showDisableCartLayoutModal}
      onClose={() => setShowDisableCartLayoutModal(false)}
    >
      <H3>{cartLayout?.label}</H3>
      <strong>Rows</strong>: {cartLayout?.rows}
      <strong>Columns</strong>: {cartLayout?.columns}
    </Modal>
  )
}

const mapStateToProps = state => ({ 
});

const mapDispatchToProps = (dispatch) => ({
  disableCartLayout: (payload, cartLayoutId) => dispatch(cartLayoutDisable(payload, cartLayoutId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DisableCartLayoutModal);
